import { MACHINE_URL } from "../../../Utils/constService";
import api from "../../../../BasicComponent/Service/api";

export const fetchMachine = (params = {}) => api.get(MACHINE_URL, { params });

export const fetchMachineById = (id) => api.get(`${MACHINE_URL}/${id}`);
export const postMachine = (data) => api.post(MACHINE_URL, data);
export const putMachine = (data, id) => api.put(`${MACHINE_URL}/${id}`, data);
export const deleteMachine = (id) => api.delete(`${MACHINE_URL}/${id}`);
export const pauseResumeApiCall = (uuid, enableIngestion) =>
  api.post(`${MACHINE_URL}/${uuid}/ingestion`, null, {
    params: { enableIngestion },
  });
